<template>
  <v-row align="center" class="px-3 mt-1 mb-10">
    <h1>{{title | localize}}</h1>
    <v-divider class="mt-5 ml-3" />
  </v-row>
</template>

<script>
export default {
    props: {
        title: {
            require : true
        }
    }
};
</script>

<style>
</style>